import { render, staticRenderFns } from "./MatrizRisco.vue?vue&type=template&id=ecc8748c&scoped=true"
import script from "./MatrizRisco.vue?vue&type=script&lang=js"
export * from "./MatrizRisco.vue?vue&type=script&lang=js"
import style0 from "./MatrizRisco.vue?vue&type=style&index=0&id=ecc8748c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc8748c",
  null
  
)

export default component.exports